import React from 'react';
import { Card } from './ui/Card';
export function ExperienceTimeline() {
  const roles = [{
    title: 'Managing Partner',
    company: 'HyRoad Consulting',
    period: 'Present',
    description: 'Helping companies design scalable revenue architecture and go-to-market strategies. Serving as CRO to accelerate market expansion and restructure sales teams.',
    highlight: 'Strategic Advisory & Revenue Architecture'
  }, {
    title: 'Vice President',
    company: 'MITO Material Solutions',
    period: 'Previous',
    description: 'Led commercial strategy and revenue generation for advanced materials innovator.',
    highlight: 'Delivered 13X revenue growth'
  }, {
    title: 'Vice President',
    company: 'RICS Software',
    period: 'Previous',
    description: 'Directed sales organization and go-to-market execution for retail management SaaS platform.',
    highlight: 'Drove 34% YoY growth'
  }, {
    title: 'VP Sales & Marketing',
    company: 'Team Pride Athletics',
    period: 'Previous',
    description: 'Spearheaded national sales initiatives and marketing strategy.',
    highlight: 'Achieved 200% growth'
  }, {
    title: 'Enterprise Sales Consultant',
    company: 'Octagon Sports & Entertainment',
    period: 'Previous',
    description: 'Consulted on high-value enterprise sales and sponsorship strategies.',
    highlight: 'Global brand partnerships'
  }, {
    title: 'National Sales Manager',
    company: 'TaylorMade adidas Golf',
    period: 'Previous',
    description: 'Built and led the corporate/B2B division from startup level to major revenue contributor.',
    highlight: 'Grew division from $1.8M to $35M in 36 months'
  }];
  return <section id="experience" className="py-24 bg-navy-900" data-id="element-132">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-133">
        <div className="mb-16" data-id="element-134">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-135">
            Leadership <span className="text-gradient" data-id="element-136">Experience</span>
          </h2>
          <p className="text-lg text-white/50" data-id="element-137">
            25+ years of progressive revenue leadership roles.
          </p>
        </div>

        <div className="relative border-l border-navy-600 ml-3 md:ml-6 space-y-12" data-id="element-138">
          {roles.map((role, index) => <div key={index} className="relative pl-8 md:pl-12" data-id="element-139">
              <div className="absolute -left-[5px] top-2 w-2.5 h-2.5 rounded-full bg-gold ring-4 ring-navy-900" data-id="element-140"></div>

              <Card hover className="p-6 md:p-8" data-id="element-141">
                <div className="flex flex-col md:flex-row md:items-start justify-between mb-4 gap-2" data-id="element-142">
                  <div data-id="element-143">
                    <h3 className="text-xl md:text-2xl font-bold text-white" data-id="element-144">
                      {role.title}
                    </h3>
                    <div className="text-lg text-gold font-medium" data-id="element-145">
                      {role.company}
                    </div>
                  </div>
                  <div className="inline-flex items-center px-3 py-1 rounded-full bg-navy-800 text-white/60 text-sm font-medium whitespace-nowrap self-start" data-id="element-146">
                    {role.period}
                  </div>
                </div>

                <p className="text-white/50 mb-4 leading-relaxed" data-id="element-147">
                  {role.description}
                </p>

                <div className="inline-flex items-center gap-2 text-sm font-medium text-gold bg-gold/10 px-3 py-1.5 rounded-md" data-id="element-148">
                  <span className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-149"></span>
                  {role.highlight}
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}